import Plyr from 'plyr';

export const defaultVideoPlayerOptions: Plyr.Options = {
  quality: {
    default: 720,
    options: [720],
  },
  settings: ['quality', 'speed'],
  controls: [
    'play',
    'progress',
    'current-time',
    'mute',
    'volume',
    'settings',
    'captions',
    'pip',
    'airplay',
    'fullscreen',
  ],
  fullscreen: {
    enabled: true,
    iosNative: true,
  },
  keyboard: {
    focused: true,
    global: true,
  },
};
